/* eslint-disable */
import WebFont from 'webfontloader';
import './jquery-global';
import Isotope from 'isotope-layout';
import CountUp from 'countup.js';
import 'waypoints/lib/jquery.waypoints.min';
import './history.js';
import './countdown.js';

/**
 * Lazyload fonts with WebFontLoader
 */
WebFont.load({
  google: {
    families: ['Roboto', 'Oxygen Mono', 'Muli:300,400,600', 'Material Icons'],
  },
});

/**
 * Lazyload images
 * Add simple support for background images
 */
document.addEventListener('lazybeforeunveil', function(e) {
  let bg = e.target.getAttribute('data-bg');
  if (bg) {
    e.target.style.backgroundImage = `url(${bg})`;
  }
});

let iso;

const isotopeGrid = () => {
  let $grid = document.getElementById('grid');

  if($grid){
    iso = new Isotope($grid, {
      itemSelector: '.grid__card',
      masonry: {
        columnWidth: 200,
      },
      layoutMode: 'fitRows',
    });

    let filterElem = document.getElementById("grid-filter");

    $(".js-filter-anchor").on("click", function(e){
      //e.preventDefault();
      let filterValue = e.target;
      filterValue = filterValue.getAttribute('data-filter');
      iso.arrange({ filter: filterValue });
    });

    filterElem.addEventListener('click', function(e){
      e.preventDefault();
        let filterValue = e.target;
      /*  let t = $(this);
        $('.grid__button').removeClass('is-active');
        t.addClass('is-active');*/
    if(filterValue.className != "grid__button"){
      filterValue = filterValue.parentNode;
    }
      filterValue = filterValue.getAttribute('data-filter');
      iso.arrange({ filter: filterValue });
    });

    
    }else{
      return false;
    }
}


    
isotopeGrid();

$(document).ready(function() {

  $('#country-modal').on('shown.bs.modal', function () {
    $('.modal-body ul li a').trigger('focus');
  });

  //const countItUp = (target) => {
  //  $("#" + target).waypoint(function () {
  
  //      var options = {  
  //          useEasing: true,
  //            useGrouping: true,
  //            separator: ' ',
  //            decimal: '.',
  //      };
  
  //      var countFrom = $("#" + target).data('from'),
  //          countTo = $("#" + target).data('to'),
  //          countDuration = $("#" + target).data('duration');
  
  //      //console.log(countTo); 
  //      var numAnim = new CountUp(target, countFrom, countTo, 0, 2.5, options);
  //      if (!numAnim.error) {
  //          numAnim.start();
  //      } else {
  //          console.error(numAnim.error);
  //      }
  
  //  }, {
  //      offset: "100%",
  //  });
  //}    
  
  //let stats = ['data-number-1', 'data-number-2', 'data-number-3', 'data-number-4'];
  //    stats.forEach(function(el){
  //       countItUp(el);
  //  });



  const layoutIsotope = () => {
    iso.layout();
  }

  let $faqGrid = $('.faq__grid');

  $faqGrid.on( 'click', '.faq__button', function( event ) {
    var $title = $( event.target );
    var $colourItem = $title.parents('.grid__card');
    var isOpen = $colourItem.hasClass('js-accordion-open');
    // close other accordion

    console.log($title);
    $faqGrid.find('.js-accordion-open').removeClass('js-accordion-open')
      .find('.card__body').slideUp( 'normal', layoutIsotope );
      $faqGrid.find('.icon__chevron').addClass('icon__chevron--bottom');
    if ( !isOpen ) {
      $colourItem.addClass('js-accordion-open')
        .find('.card__body').slideDown( 'normal', layoutIsotope );
      $title.find('.icon__chevron--bottom').removeClass('icon__chevron--bottom');
    }
    });

    // toggle click on first grid card.

    //$('.grid__button:first-of-type').trigger('click').addClass('is-active'); // hide all the others.
    

  $('.js-toggle-search').on('click', function () {
    $('.js-search-bar').toggleClass('is-visible');
    $('.navbar').toggleClass('has-search-visible');
    if ($('.js-search-bar').hasClass('is-visible')) {
        $('.js-search-form > input').focus();
    } else {
        $('.js-search-form').blur();
    }
    });

    $('.js-toggle-faqs').on('click', function (e) {
        e.preventDefault();
        // find parent
        let oldText = $(this).text();
        $(this).toggleClass('is-active').hide();
        $(this).parent().hide();
        let target = $(this).data('target');
        $(this).parent().parent().find('.hidden' + '.' + target).toggleClass('hidden');
        layoutIsotope();
        // trigger isotope.
    });

  $(window).scroll(function () {
    if ($(document).scrollTop() > 100) {
        $("#history .navbar").addClass("scrolled");
    } else {
        $("#history .navbar").removeClass("scrolled");
    }
  });

  // Smooth scroll animation
  $(".js-sidebar-menu nav ul li a[href^='#']").click(function(e) {
    e.preventDefault();

    let nav = $( '.navbar' ).outerHeight();
    let position = $($(this).attr("href")).offset().top - nav;
    $(this).parent().parent().find('.active').removeClass('active');

    if(!($(this).parent().hasClass('active'))){
      $(this).parent().addClass('active');
    }

    $("body, html").animate({
      scrollTop: position
    }, 750 );
  });

  $('.js-value-grid').click(function(event) {
    $('.value-active').removeClass('value-active');
    $('.desc-active').removeClass('desc-active');
   

    $(event.target).closest('.value__card').addClass('value-active');
    let activeDesc = $(event.target).closest('.value__card').attr('data-filter');
    console.log(activeDesc);
    $(activeDesc).addClass('desc-active');
  });
/*
  let $valueDesc = $('.value__description');

  $('.js-value-grid').on('click', '.card__item', function(event) {
    let target = $(this).attr('data-filter');
    $('.js-value-grid').find('.active').removeClass('.active');


    if(!(target.find('.active'))){
      target.find('.value__card').addClass('.active');
    }


    let currentActive = $('.value__grid').find('.active');

    $valueDesc.find('.desc-active').removeClass('desc-active');
    console.log(target);
    if($(target).attr('data-filter') != currentActive){
      $(target).children().addClass('active');
    }

  });*/

  $(".navbar-nav .nav-item").on("click", function(){
    console.log($(this));
    $(".nav").find(".active").removeClass("active");
    $(this).addClass("active");
 });

 $('.navbar-toggler').on('click', function(){
   $('.navbar').toggleClass('mobile-show');
 })

});


// WEBPACK FOOTER //
// ./scripts/components/common.js